import { useEffect, useState } from "react";
import { getAllDepartamentos } from "../../../services/departamento.service";
import { getAllPaises } from "../../../services/pais.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { DepartamentoList } from "../../../modules/departamento/DepartamentoList";

export const DepartamentoPage = () => {
  const [busqueda, setBusqueda] = useState("");
  const [departamentos, setDepartamentos] = useState(null);
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";

  useEffect(() => {
    obtenerDepartamentos();
  }, []);

  const obtenerDepartamentos = async () => {
    try {
      const [departamentosData, paisesData] = await Promise.all([
        getAllDepartamentos(),
        getAllPaises().catch(() => []),
      ]);

      // Crear un mapa de países por ID para búsqueda rápida
      const paisesMap = {};
      if (paisesData && paisesData.length > 0) {
        paisesData.forEach((pais) => {
          paisesMap[pais.idPais] = pais;
        });
      }

      // Enriquecer los departamentos con información del país
      const departamentosConPais = departamentosData.map((departamento) => {
        const pais = paisesMap[departamento.idPais];
        return {
          ...departamento,
          pais: pais || null,
        };
      });

      setDepartamentos(departamentosConPais);
    } catch (err) {
      console.log("Error al obtener departamentos:", err);
    }
  };

  return (
    <ContenedorPageTemplate objetos={departamentos} dirIcono={DIR_ICON_MAT} titulo="Lista de Departamentos">
      <div className="fila flex gap-4 justify-between items-center mb-2 w-full">
        <div className="flex flex-col justify-end items-center">
          <p className="total">
            Total de departamentos: <span>{departamentos?.length || 0}</span>
          </p>
        </div>
      </div>
      <DepartamentoList departamentos={departamentos} onRefresh={obtenerDepartamentos} />
    </ContenedorPageTemplate>
  );
};